import LadlesMaintenance from "@/pages/meltshop/ladles-maintenance";
import MeltShopDashboard from "../../pages/meltshop/dashboard";
import MeltshopHeatsIndex from "../../pages/meltshop/heats";
import { RouteConfig } from "./types";

export const meltshopRoutes: RouteConfig[] = [
  {
    path: "/meltshop-dashboard",
    element: <MeltShopDashboard />,
  },
  {
    path: "/meltshop-dashboard/:shiftId",
    element: <MeltShopDashboard />,
  },
  {
    path: "/meltshop-heats",
    element: <MeltshopHeatsIndex />,
    permission: "ui.navbar.meltshop.heats",
  },
  {
    path: "/meltshop-heats/:shiftId",
    element: <MeltshopHeatsIndex />,
    permission: "ui.navbar.meltshop.heats",
  },
  {
    path: "/ladle-maintenance",
    element: <LadlesMaintenance />,
    permission: "ui.navbar.meltshop.ladle-maintenance",
  },
];
